/**
 * User: Oleg Kamlowski <oleg.kamlowski@thomann.de>
 * Date: 14.12.2016
 * Time: 13:26
 *
 * The compose function creates a space delimited string used for classnames.
 * Every arguments values are checked for their "truthiness".
 *
 * If a key value pair is given and value is "truthy", its key is going to be used as a classname.
 * If only a string given, its automatically used as a classname.
 *
 *
 * Basic Examples:
 *
 * compose('base', {
 *     'show': true,
 *     'hide': false
 * });
 *
 * // == 'base show'
 *
 * ---------------------------------------------------------------------------------
 *
 * let color = 'green';
 * let size = 'big';
 * let pos = null;
 *
 * compose({
 *     [color]: color,
 *     ['font-' + size]: size,
 *     ['position-' + pos]: pos
 * });
 *
 * // == 'creen font-big'
 * // color and size variables are "truthy" so their keys are concatenated with their variable value
 * // pos variable is null and thus "falsy", no key concatenation is happening
 * ---------------------------------------------------------------------------------
 *
 * Advanced Example:
 *
 * let string = 'uppercase';
 * let array = ['italic' , 'bold'];
 * let object = {icon: true};
 *
 * let example = compose(
 *      'modal',                                    // strings; no evaluation
 *      {                                           // objects; property values are evaluated
 *          'warning': false,
 *          'show': true,
 *          'small': array.length >= 1
 *      },
 *      object,
 *      array.map((item) => 'text-' + item),       // arrays; no evaluation
 *      {
 *          ['text-' + string]: string,            // dynamic objects; (string != null) == true
 *          ['text-' + string]: null,              // dynamic objects; (null != null) == false
 *      }
 * );
 *
 * // == 'modal show small icon text-italic text-bold text-uppercase'
 *
 * @return {string}
 */
const compose = (...classes) => {
    let composed = [];

    if (classes.constructor !== Array) {
        classes = new Array(classes);
    }

    classes
        .filter((cls) => cls != null)
        .forEach((cls) => {
            switch (cls.constructor) {
                case String:
                case Number:
                    composed.push(cls);
                    break;
                case Array:
                    composed.push(compose(...cls));
                    break;
                case Object:
                    Object.keys(cls).forEach((item) => {
                        (cls[item]) && composed.push(item);
                    });
                    break;
            }
        });

    return composed.join(' ').trim();
};

module.exports = compose;


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/ClassComposer.js